import { makeAutoObservable } from 'mobx';
import { BidderAdvertiserModel, IBidderAdvertiser } from './bidder-advertiser.model';

export interface IBidderAdvertiserDetail {
	advertiser: IBidderAdvertiser;
	success: boolean;
}

export class BidderAdvertiserResponseModel implements Partial<IBidderAdvertiserDetail> {
	private _advertiser: BidderAdvertiserModel;
	private _success: boolean;

	constructor(data?: Partial<IBidderAdvertiserDetail>) {
		this._advertiser = new BidderAdvertiserModel(data?.advertiser);
		this._success = data?.success ?? false;

		makeAutoObservable(this);
	}

	get advertiser(): BidderAdvertiserModel {
		return this._advertiser;
	}

	set advertiser(value: IBidderAdvertiser) {
		this._advertiser = new BidderAdvertiserModel(value);
	}
	get success() {
		return this._success;
	}

	set success(value: boolean) {
		this._success = value;
	}

	getId() {
		return this.advertiser?.advertiser_id;
	}

	toObject() {
		return {
			advertiser: this._advertiser.toObject(),
			success: this.success,
		};
	}
}
